<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="/">Anasayfa</a></li>
            <li class="active">Referanslar</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Referanslar</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">

    <ul class="nav nav-pills sort-source" data-sort-id="portfolio" data-option-key="filter" data-plugin-options="{'layoutMode': 'fitRows', 'filter': '*'}">
      <li data-option-value="*" class="active"><a href="javascript:void(0)">Hepsi</a></li>
      <li data-option-value=".proje"><a href="javascript:void(0)">Proje</a></li>
      <li data-option-value=".danismanlik"><a href="javascript:void(0)">Danışmanlık</a></li>
      <li data-option-value=".egitim"><a href="javascript:void(0)">Eğitim</a></li>
    </ul>

    <hr>

    <div class="row">

      <div class="sort-destination-loader sort-destination-loader-showing">
        <ul class="portfolio-list sort-destination" data-sort-id="portfolio">

          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/turksat.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/turkcell.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/superonline.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/turkcell_akademi.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/vodafone.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/turk_telekom.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/garanti_teknoloji.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/halkbank.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/intertech.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/akbank.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/alternatifbank.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/aktifbank.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/hsbc.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/is_bankasi.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/softtech.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/yapikredi.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/ibtech.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/takasbank.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/arkas.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/assan_bilisim.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/borusan.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/manheim.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/mercedes.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/pakmaya.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/yemekgelir.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/anadolu_hayat_emeklilik.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/aksa.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/setur.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/tursan.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/odc.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/mostidea.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/andersan_nazali.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/assistt.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/morse_watchman.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/pavo.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/pulver_kimya.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/marport.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/gratude.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/aras_kargo.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/adeo.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl danismanlik egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/bilgeadam.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/bilginc_it.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/depar_akademi.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/pytch_ventures.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/mobistech.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/ode3d.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/aerotivelabs.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/erturk_lines.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/menokg.jpg" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/mlklab.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl proje danismanlik">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/meyer.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
          <!-- Company item-->
          <li class="col-md-3 isotope-item mt-xl egitim">
            <div class="portfolio-item">
                <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                  <span class="thumb-info-wrapper">
                    <img src="assets/img/customer/deris.png" class="img-responsive" alt="">

                  </span>
                </span>
            </div>
          </li>
          <!---->
        </ul>
      </div>
    </div>

  </div>

</div>
